import { useSessionStore, labelMap } from './SessionStore';
import { useState, useRef, useEffect } from 'react';
import { useSiteSettings } from './context/SiteSettingsContext';




const SessionDetails: React.FC = () => {
    const { sessionData, updateSession } = useSessionStore();
    const [editedTitle, setEditedTitle] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
    const logLevel = siteSettings?.frontend_log_level ?? 0;




    useEffect(() => {
        // Editiermodus verlassen und Feld zurücksetzen bei Sessionwechsel
        setIsEditing(false);
        setEditedTitle('');
    }, [sessionData?.id]);


    useEffect(() => {
        if (isEditing && inputRef.current) {
            // kleiner Delay, damit DOM-Update abgeschlossen ist
            setTimeout(() => {
                inputRef.current?.focus();
                inputRef.current?.select();
            }, 0);
        }

    }, [isEditing]);

    if (!sessionData) return <p>Keine Sitzung ausgewählt</p>;

    const handleSaveTitle = async () => {
        const success = await updateSession(sessionData.id, { name: editedTitle });
        if (success) {
            if (!isSiteSettingsLoading && logLevel >= 3) console.log('✅ Titel erfolgreich aktualisiert:', editedTitle);
            setIsEditing(false);
            setEditedTitle('');
        } else {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error('❌ Fehler beim Aktualisieren des Titels');
        }
    };



    return (
        <div id="onboarding-step-four" className="bg-white rounded-lg">
            <div className="_noteHeader_1iydr_1">
                <div className="_clientDetails_1iydr_43">
                    <div className="_initDetails_1iydr_70">
                        <div className="_clientHeader_1iydr_54">

                            <button
                                className="_button_19rto_40 _primary_19rto_127 _ghost_19rto_149 !font-normal !text-xs !p-0 !m-0 text-primary-500"
                                onClick={() => {
                                    if (isEditing) {
                                        handleSaveTitle();
                                    } else {
                                        setIsEditing(true);
                                        setEditedTitle(sessionData.name);
                                    }
                                }}
                            >
                                <div className="_btnFlex_19rto_32">
                                    {isEditing ? 'Speichern' : 'Sitzungsdetails'}
                                    <div className="_btnAddon_19rto_56 _btnRightAddon_19rto_65">
                                        <div className="_btnAddon_19rto_56 _btnRightAddon_19rto_65">
                                            {isEditing ? (
                                                // Disketten-/Speicher-Symbol
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zM12 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm3-10H5V5h10v4z" fill="#32768D" />
                                                </svg>
                                            ) : (
                                                // Dein aktuelles Stift-SVG
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.69723 13.0156C3.29056 13.0156 2.91056 12.8756 2.63723 12.6156C2.29056 12.289 2.1239 11.7956 2.1839 11.2623L2.43056 9.10231C2.47723 8.69564 2.7239 8.15565 3.01056 7.86231L8.4839 2.06898C9.85056 0.622311 11.2772 0.582311 12.7239 1.94898C14.1706 3.31564 14.2106 4.74231 12.8439 6.18898L7.37056 11.9823C7.09056 12.2823 6.57056 12.5623 6.1639 12.629L4.01723 12.9956C3.9039 13.0023 3.8039 13.0156 3.69723 13.0156Z" fill="#32768D" />
                                                    <path d="..." fill="#32768D" />
                                                </svg>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </button>


                        </div>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="cursor-pointer">
                            <path d="M8 10C9.10457 10 10 9.10457..." stroke="#32768D"></path>
                            <path d="M1.33594 8.59021V7.41687..." stroke="#32768D"></path>
                        </svg>
                    </div>
                    <div className="_clientGroup_1iydr_77">
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Name</span>
                            {isEditing ? (
                                <input
                                    className="_clientValue_1iydr_104 border border-primary-500 rounded px-1"
                                    value={editedTitle}
                                    onChange={(e) => setEditedTitle(e.target.value)}
                                    ref={inputRef}

                                />
                            ) : (
                                <span className="_clientValue_1iydr_104">{sessionData.name}</span>
                            )}
                        </div>
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Typ</span>
                            <span className="_clientValue_1iydr_104">{labelMap[sessionData.participation_type || "k.A."]}</span>
                        </div>
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Template</span>
                            <span className="_clientValue_1iydr_104">{sessionData.template_used}</span>
                        </div>
                    </div>
                </div>
                <div className="_sessionDetails_1iydr_44">

                    <div className="_clientGroup_1iydr_77">
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Datum</span>
                            <span className="_clientValue_1iydr_104">
                                {new Date(sessionData.date).toLocaleDateString('de', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </span>
                        </div>
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Dauer</span>
                            <span className="_clientValue_1iydr_104">{Math.round(Number(sessionData.length) / 60)} minuten</span>
                        </div>
                        <div className="_eachGroup_1iydr_93">
                            <span className="_clientLabel_1iydr_97 !font-bold">Aufnahme</span>
                            <span className="_clientValue_1iydr_104">{labelMap[sessionData.recording_type || "k.A."]}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionDetails;
